import { render } from "./ConsolidatedAccountScreen.vue?vue&type=template&id=451ef67d"
import script from "./ConsolidatedAccountScreen.vue?vue&type=script&lang=js"
export * from "./ConsolidatedAccountScreen.vue?vue&type=script&lang=js"

import "./ConsolidatedAccountScreen.vue?vue&type=style&index=0&id=451ef67d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__